import { render } from "./InspectionDialog.vue?vue&type=template&id=d21204fc"
import script from "./InspectionDialog.vue?vue&type=script&lang=js"
export * from "./InspectionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__